import { wendeAlleAn, type Operation, type UiDaten } from "@gui-creator/gemeinsam";

export type Stand = { revision: number; daten: UiDaten };

/** Nur die direkte Folgerevision wird angewendet; Älteres ist schon da, eine Lücke verlangt Neuladen. */
export function verarbeite(lokal: Stand, e: { revision: number; operationen: Operation[] }): Stand | "neu_laden" {
  if (e.revision <= lokal.revision) return lokal;
  if (e.revision !== lokal.revision + 1) return "neu_laden";
  try {
    return { revision: e.revision, daten: wendeAlleAn(lokal.daten, e.operationen).ui };
  } catch {
    return "neu_laden";
  }
}

/** Frisch geladene Daten plus ausstehende eigene Änderungen; enthält der Abruf vielleicht schon eine davon, erst nach dem Senden neu laden. */
export function nachAbruf(geholt: Stand, bestaetigt: number | undefined, ausstehend: Operation[][]): Stand | "spaeter" {
  if (ausstehend.length === 0) return geholt;
  if (bestaetigt === undefined || geholt.revision !== bestaetigt) return "spaeter";
  try {
    return { revision: geholt.revision, daten: wendeAlleAn(geholt.daten, ausstehend.flat()).ui };
  } catch {
    return "spaeter";
  }
}

/** Welche Slots und ob UI-Felder eine Änderung berührt, für den Hinweis „geändert von …“. */
export function betroffen(ops: Operation[]): { slots: number[]; ui: boolean } {
  const slots = new Set<number>();
  let ui = false;
  for (const op of ops) {
    if (op.art === "slot_setzen") slots.add(op.index);
    else if (op.art === "slots_leeren") op.indizes.forEach((i) => slots.add(i));
    else if (op.art === "slots_verschieben") op.paare.forEach((p) => (slots.add(p.von), slots.add(p.nach)));
    else if (op.art === "listenbereich_setzen") op.bereich.slots.forEach((i) => slots.add(i));
    else ui = true;
  }
  return { slots: [...slots].sort((a, b) => a - b), ui };
}
